const stats = [
  { label: 'Países disponibles', value: '50+' },
  { label: 'Viajeros felices', value: '150+' },
  { label: 'Calificación', value: '4.9' },
  { label: 'Años de experiencia', value: '2+' },
]

const services = [
  { title: 'Tours internacionales', desc: 'Paquetes a más de 50 destinos en todo el mundo.' },
  { title: 'Paquetes de viaje', desc: 'Vuelo + hotel + traslados, todo incluido.' },
  { title: 'Trámite de visas', desc: 'Asesoría completa en tu proceso de visa.' },
  { title: 'Pasaportes', desc: 'Te acompañamos en cada paso del trámite.' },
]

export default function WeContent() {
  return (
    <div className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">

        <div className="grid grid-cols-1 items-start gap-12 lg:grid-cols-2 lg:gap-16">

          {/* Video */}
          <div className="lg:pr-4">
            <div className="relative overflow-hidden rounded-3xl shadow-xl" style={{ paddingTop: '60%' }}>
              <video
                src="/Video/Despega.mp4"
                autoPlay loop muted playsInline
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div
                className="absolute inset-0"
                style={{ background: 'rgba(46,56,164,0.50)' }}
              />
              <div className="absolute bottom-0 left-0 right-0 p-7">
                <div
                  className="rounded-2xl p-5"
                  style={{ background: 'rgba(255,255,255,0.10)', backdropFilter: 'blur(12px)', border: '1px solid rgba(255,255,255,0.18)' }}
                >
                  <p className="text-white font-medium text-sm leading-relaxed">
                    "Creemos que viajar transforma vidas. Cada destino, trámite y experiencia, fácil, seguro y memorable."
                  </p>
                  <p className="mt-2 text-xs font-bold" style={{ color: '#F5A020' }}>— Despega GT</p>
                </div>
              </div>
            </div>
          </div>

          {/* Texto */}
          <div>
            <p className="text-sm font-semibold uppercase tracking-widest mb-4" style={{ color: '#F5A020' }}>
              Sobre nosotros
            </p>
            <h2 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl leading-tight">
              Despega GT,{' '}
              <span style={{ color: '#2E38A4' }}>tu puerta al mundo</span>
            </h2>

            <div className="mt-6 space-y-4 text-sm text-gray-500 leading-relaxed">
              <p>
                Somos una agencia de viajes comprometida con convertir tus sueños en experiencias reales.
                Viajes nacionales e internacionales, tours, visas, pasaportes y acompañamiento en cada paso.
              </p>
              <p>
                Más de 50 países disponibles. Precios competitivos, atención personalizada y la tranquilidad
                de viajar con expertos que te respaldan desde el primer día.
              </p>
            </div>

            <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {services.map((s) => (
                <div
                  key={s.title}
                  className="flex flex-col p-4 rounded-xl border border-gray-100 hover:border-gray-200 transition"
                >
                  <p className="font-bold text-sm text-gray-900">{s.title}</p>
                  <p className="text-xs text-gray-400 mt-1">{s.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-8">
              <a
                href={`https://wa.me/50239990332?text=${encodeURIComponent('Hola, quiero cotizar un viaje con Despega GT')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-7 py-3.5 rounded-xl font-bold text-white text-sm shadow transition hover:opacity-90"
                style={{ background: '#2E38A4' }}
              >
                Cotiza tu próximo viaje
              </a>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div
          className="mt-20 rounded-3xl overflow-hidden"
          style={{ background: 'linear-gradient(135deg, #1E2578 0%, #2E38A4 100%)' }}
        >
          <div className="grid grid-cols-2 lg:grid-cols-4">
            {stats.map((stat, i) => (
              <div
                key={stat.label}
                className="flex flex-col items-center justify-center py-10 px-6 text-center"
                style={{ borderRight: i < stats.length - 1 ? '1px solid rgba(255,255,255,0.10)' : 'none' }}
              >
                <div className="text-4xl font-extrabold text-white">{stat.value}</div>
                <div className="mt-1 text-xs font-medium text-white/50 uppercase tracking-wider">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  )
}
